export const TRAVELMODE_DONE = 'travelmode/DONE';
export const TRAVELMODE_WALKING = 'travelmode/WALKING';
export const TRAVELMODE_CYCLING = 'travelmode/CYCLING';
export const TRAVELMODE_STRAIGHT = 'travelmode/DIRECT';
